import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { addPaymentToOrderInProgress, closeNoOpTender } from '../actions/order'
import { PAYMENT_TYPES } from '../utils/paymentTypes'

/**
 * Hook for closing free orders whether new or previously tabbed
 *
 * @returns {Object} - Object with close function
 */
const useCloseFreeOrder = () => {
  const dispatch = useDispatch()

  // Two routes for closing a free order
  // 1. A new free order, closes through a closeNoOpTender dispatch
  // 2. A tabbed free order, closes via addPaymentToOrderInProgress dispatch to close the existing tab order
  const closeFreeOrder = useCallback(
    (orderUuid, isTabOrder) => {
      if (isTabOrder) {
        dispatch(
          addPaymentToOrderInProgress({ tenderAmountInCents: 0, paymentType: PAYMENT_TYPES.CASH, shortDescription: 'Cash' }),
        )
        return
      }
      dispatch(closeNoOpTender({ orderUuid, tender: { name: PAYMENT_TYPES.CASH, displayName: 'Cash' } }))
    },
    [dispatch],
  )

  return { closeFreeOrder }
}

export default useCloseFreeOrder
